import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import axios from "axios";
import { getAllfund } from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import {
  Grid
} from "@material-ui/core";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function FillFund() {
  const [fund, setfund] = useState([]);
  const [fundpost, setFundpost] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    getAllfund()
      .then((res) => {
        setfund(res.data);
      
        setIsLoading(true);
      })
      .catch((err) => {
       
        setfund([]);

        setIsLoading(false);
      });

    return () => {
     
    };
  }, []);
  const initialFValues = {
    mobile_number: "",
    amount: "",
    trans_code:"",
    
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
      if ("mobile_number" in fieldValues) {
        if (fieldValues.mobile_number == "") {
          temp.mobile_number = " رقم الموبايل مطلوب";
        } else if (!/[0-9]/.test(fieldValues.mobile_number)) {
          temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام";
        } else {
          temp.mobile_number = "";
        }
  
      }  
    if ("amount" in fieldValues)
      temp.amount = fieldValues.amount ? "" : "  الكمية مطلوبة";
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const data = {
        mobile_number: loginInput.mobile_number,
        amount: loginInput.amount,
        trans_code: fundpost,
        
      };

      axios
        .post(`${BaseUrl}/api/TransferFund`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.status == 200) {
            sweetalert("تم تعبئة بنجاح", {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          } else {
            sweetalert(loginInput.error_list);
            setLogin({ ...loginInput, error_list: res.data.message });
          }
        });
    }
  };

  return (
    <div className="main-div">
      <h3 className="titlepage">تعبئة رصيد</h3>

      <Form className="form-group new-design" onSubmit={handleSubmit}>
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الهاتف"
              name="mobile_number"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              className="form-control"
              error={errors.mobile_number}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الكمية"
              name="amount"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              className="form-control"
              error={errors.amount}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="select">
                <select
                className="form-control"
                name="trans_code"
                class="select-text"
                required
                onChange={(e) => setFundpost(e.target.value)}
              >
                <option selected disabled>
                  اختر نوع التحويل 
                </option>
                
                  <option value="prepaid">مسبق الدفع</option>
                  <option value="postpaid">لاحق الدفع</option>
            
               
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label"> نوع التحويل</label>
            </div>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Controls.Button
            type="submit"
            text="حفظ"
            onClick={addForm}
            variant="contained"
            className="btn-submit"
          ></Controls.Button>
        </Grid>
      </Form>
    </div>
  );
}
